<template>
  <!-- <ViewFile ref="viewFileRef"></ViewFile> -->
  <div
    ><div
      style="
        height: 600px;
        font-size: 18px;
        background-color: #fff;
        padding: 15px;
        box-sizing: border-box;
      "
    >
      <i class="el-icon-s-operation icon"></i>常用文档
      <div style="margin-top: 100px">
        <li v-if="document.operationName"
          ><a
            style="text-decoration: underline"
            href="#"
            @click="downExcelTemplate(document.operationUrl, 'operationUrl')"
          >
            {{ document.operationName }}</a
          >
        </li>
        <li v-if="document.operationName"
          ><a
            style="text-decoration: underline"
            href="#"
            @click="downExcelTemplate(document.speciUrl)"
          >
            {{ document.speciName }}</a
          >
        </li>
        <li v-if="indexType == 'wm' && document.deditName"
          ><a
            style="text-decoration: underline"
            href="#"
            @click="downExcelTemplate(document.deditUrl)"
          >
            {{ document.deditName }}</a
          >
        </li>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '@/api/homepage/homepage.js';
  import templateApi from '@/api/template';
  export default {
    name: 'documentView',
    props: ['indexType'],
    data() {
      return {
        document: { operationName: '', operationUrl: '', speciName: '', speciUrl: '' },
        groupType: '',
      };
    },
    mounted() {
      // setTimeout(() => {
      //   this.getData();
      // }, 1000);
    },
    methods: {
      async getData() {
        console.log('获取常用文档');
        let { data } = await this.$axios.post(API.GETDOCUMENT, {
          departmentCode: this.userInfo.departmentCode,
          businessGroup: this.indexType,
        });
        console.log(data.data, '常用文档');
        if (data.code == '0') {
          this.document = data.data;
          console.log('data==', this.document);
        }
      },
      async downExcelTemplate(fileKey) {
        // if (isOperate == 'operationUrl') {
        //   this.$message.info('此部分暂未上传文档，敬请期待');
        //   return;
        // }
        if (!fileKey || !fileKey.includes('templates')) {
          this.$message.error('请传递模板');
          return;
        }
        const { data } = await this.$axios.post(templateApi.DOWN_EXCEL_TEMPLATE_API, {
          fileKey,
        });
        if (data.code === 0) {
          window.location.href = data.data;
          this.$message.success('文档下载成功');
        } else {
          this.$message.error('文档下载失败');
        }
      },
    },
    watch: {
      indexType: {
        handler(val) {
          if (val) {
            this.groupType = val;
            setTimeout(() => {
              this.getData();
            }, 1000);
          } else {
            this.cancel();
          }
        },
        immediate: true,
        deep: true,
      },
    },
    // components: { ViewFile },
  };
</script>

<style scoped>
  .icon {
    color: #02a7f0;
    font-size: large;
    font-weight: bold;
    margin-right: 10px;
  }
  a {
    color: #1e1aff;
    font-size: 16px;
  }
</style>
